/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_Make_AdminInputs */

const en_us2_clubs_make_admin = /** @type {(inputs: Clubs_Make_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Make admin`)
};

const pt_br2_clubs_make_admin = /** @type {(inputs: Clubs_Make_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tornar admin`)
};

const es_419_clubs_make_admin = /** @type {(inputs: Clubs_Make_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hacer admin`)
};

const pt_pt2_clubs_make_admin = /** @type {(inputs: Clubs_Make_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tornar admin`)
};

const fr_fr2_clubs_make_admin = /** @type {(inputs: Clubs_Make_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nommer admin`)
};

const de_de2_clubs_make_admin = /** @type {(inputs: Clubs_Make_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zum Admin machen`)
};

const it_it2_clubs_make_admin = /** @type {(inputs: Clubs_Make_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rendi admin`)
};

/**
* | output |
* | --- |
* | "Make admin" |
*
* @param {Clubs_Make_AdminInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_make_admin = /** @type {((inputs?: Clubs_Make_AdminInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Make_AdminInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_make_admin(inputs)
	if (locale === "es-419") return es_419_clubs_make_admin(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_make_admin(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_make_admin(inputs)
	if (locale === "de-DE") return de_de2_clubs_make_admin(inputs)
	if (locale === "it-IT") return it_it2_clubs_make_admin(inputs)
	return en_us2_clubs_make_admin(inputs)
});
export { clubs_make_admin as "clubs.make_admin" }